import {
  ComponentRef,
  Directive,
  Input,
  OnDestroy,
  ViewContainerRef,
} from '@angular/core';
import { PrLoaderComponent } from './pr-loader.component';

@Directive({
    selector: '[prLoader]',
    standalone: false
})
export class PrLoaderDirective implements OnDestroy {
  private componentInstance: ComponentRef<PrLoaderComponent> = null;
  private destroyTimeout;

  @Input() set loading(loading: boolean) {
    this.toggleLoader(loading);
  }

  constructor(
    private viewContainerRef: ViewContainerRef,
  ) {}

  toggleLoader(loading: boolean) {
    if (!this.componentInstance && loading) {
      clearTimeout(this.destroyTimeout);
      this.createLoaderComponent();
      this.makeComponentAChild();
    } else if (this.componentInstance) {
      this.componentInstance.instance.elRef.nativeElement.classList.add(
        'fadeIn',
      );
      this.destroyTimeout = setTimeout(() => this.destroy(), 1000);
    }
  }

  private createLoaderComponent() {
    this.componentInstance =
      this.viewContainerRef.createComponent(PrLoaderComponent);
  }

  private makeComponentAChild() {
    const loaderComponentElement =
      this.componentInstance.location.nativeElement;
    const sibling: HTMLElement = loaderComponentElement.previousSibling;
    sibling.insertBefore(loaderComponentElement, sibling.firstChild);
  }

  destroy() {
    if (this.componentInstance) {
      this.componentInstance.destroy();
      this.componentInstance = undefined;
    }
  }

  ngOnDestroy(): void {
    this.destroy();
  }
}
